import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ArrowUp: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 13, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 16) / 13}
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.3638 5.64508C12.362 5.64333 12.3603 5.64161 12.3585 5.63986L6.97467 0.248926C6.93189 0.20638 6.88462 0.168591 6.83372 0.136186L6.67869 0.0516218L6.57299 0.016376H6.49546C6.37668 -0.00545865 6.25489 -0.00545865 6.13607 0.016376H6.06561H5.98104L5.86123 0.0797987C5.79448 0.116069 5.73284 0.161092 5.678 0.21368L0.272994 5.63986C-0.0889455 5.99893 -0.0912907 6.58344 0.267775 6.94538C0.269492 6.94713 0.271243 6.94885 0.272994 6.9506C0.63784 7.2987 1.21182 7.2987 1.5767 6.9506L4.79715 3.73718C4.93609 3.60095 5.15919 3.60313 5.29542 3.7421C5.35881 3.80675 5.39488 3.89329 5.39613 3.98383V14.4768C5.3961 14.9866 5.80937 15.4 6.31923 15.4C6.82909 15.4 7.2424 14.9868 7.24246 14.4769V14.4768V3.98383C7.24521 3.78927 7.40515 3.63372 7.59971 3.63646C7.69022 3.63775 7.7768 3.67379 7.84145 3.73718L11.0478 6.9506C11.4136 7.30319 11.9928 7.30319 12.3586 6.9506C12.7205 6.59153 12.7229 6.00702 12.3638 5.64508Z"
        fill="currentColor"
      />
    </svg>
  )
})

ArrowUp.displayName = 'ArrowUp'
